import apiFetch from '../../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/purchase/${dossierId}/DoubleTransferCheck`, method: 'GET', body: null, token: token, lastAccessDate })
}
